'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _comment = require('./comment');

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PositiveSentiment = function PositiveSentiment(_ref) {
  var posts = _ref.posts;

  //
  var comments = _lodash2.default.transform(posts, function (result, value, key) {
    var totals = _lodash2.default.get(value, 'totals');
    var assets = _lodash2.default.get(value, 'posts', []);
    var profilePic = _lodash2.default.get(value, 'profilePic');
    var withComments = _lodash2.default.filter(assets, function (asset) {
      return _lodash2.default.has(asset, 'trackedAsset.featuredComments');
    });
    if (!_lodash2.default.isEmpty(withComments)) {
      _lodash2.default.forEach(withComments, function (postWithComments) {
        _lodash2.default.forEach(postWithComments.trackedAsset.featuredComments, function (comment) {
          _lodash2.default.set(comment, 'asset', postWithComments);
          _lodash2.default.set(comment, 'totals', totals);
          _lodash2.default.set(comment, 'profilePic', profilePic);
          _lodash2.default.set(comment, 'handle', key);
          result.push(comment);
        });
      });
    }
    return result;
  }, []);
  if (_lodash2.default.isEmpty(comments)) {
    return null;
  }

  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Card.Header,
        null,
        'Positive Sentiment'
      ),
      _react2.default.createElement(
        _semanticUiReact.Card.Meta,
        null,
        'examples of positive comments, captured from the campaign'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Card.Group,
        { itemsPerRow: 'three' },
        _lodash2.default.map(comments, function (comment) {
          return _react2.default.createElement(_comment2.default, comment);
        })
      )
    )
  );
};

PositiveSentiment.propTypes = {
  posts: _propTypes2.default.object.isRequired
};

exports.default = PositiveSentiment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/instagram-report2/positive-sentiment.js
// module id = 2195
// module chunks = 1